import { render, staticRenderFns } from "./ListAiPushNotificationConfigurations.vue?vue&type=template&id=4ca57e31&scoped=true&"
import script from "./ListAiPushNotificationConfigurations.vue?vue&type=script&lang=js&"
export * from "./ListAiPushNotificationConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./ListAiPushNotificationConfigurations.vue?vue&type=style&index=0&id=4ca57e31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca57e31",
  null
  
)

export default component.exports